import React, {useContext, useEffect, useState} from 'react';
import './add_task.css';
import GetAllUser from '../../api/user/get_all_user';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@mui/material/TextField';
import { Menu, MenuItem, Button, Fade, List, ListItem, FormControlLabel, Checkbox, Typography } from '@mui/material';
import AddTaskAPICall from '../../api/task/add_task';
import Loader from '../../components/loader/loader';
import AlertDialog from '../../components/alert dialog/dialog';
import { AuthorizationContext } from '../../context/authorizationContext';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import DeleteIcon from '@mui/icons-material/Delete';

const AddTask = ()=>{

    const { userDetail, setPath } = useContext(AuthorizationContext);

    setPath(window.location.pathname);

    const [task_detail, setTaskDetail] = useState({});
    const [all_user, setAllUser] = useState([]);
    const [status, setStatus] = useState();
    const all_status = userDetail?.admin === true ? ["Not Started", "Development", "Error", "Reference", "Completed"] : ["Not Started", "Development", "Error", "Review", "Reference"];
    const [selected_user, setSelectedUser] = useState([]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [visible_loader, setVisibleLoader] = useState(false);
    const [visible_dialog, setVisibleDialog] = useState(false);
    const [title_dialog, setTitleDialog] = useState("");
    const [button_dialog, setButtonDialog] = useState("");
  
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const ChangeOptionAddUser = ()=>{
        selected_user.map((assigned)=>{
            if(all_user.length > 0){
                all_user.map((all, index)=>{
                    if(index > -1 && all === assigned){
                        all_user.splice(index, 1);
                    }
                })
            }
        })
        // console.log(selected_user, all_user);
    };

    const AddTaskAPI = ()=>{
        console.log("Pritning task detail", task_detail);
        debugger;
        if(task_detail?.title === "" || task_detail?.status === "" || task_detail?.assigned?.length === 0){
            setTitleDialog("Please enter all required fields.");
            setButtonDialog("Close");
            setVisibleDialog(true);
        }
        else{
            setVisibleLoader(true);
            AddTaskAPICall(task_detail, (res)=>{
                // console.log("Printing response of add task in add task", res);
                if(res.data.status){
                    setVisibleLoader(false);
                    setTitleDialog("Task assigned successfully.!");
                    setButtonDialog("Ok");
                    setVisibleDialog(true);
                }
                else{
                    setVisibleLoader(false);
                    setTitleDialog(res.data.data);
                    setButtonDialog("Close");
                    setVisibleDialog(true);
                }
            }, (err)=>{
                console.log(err);
            })
        }
    }

    useEffect(()=>{
        setVisibleLoader(true);
        GetAllUser({companyId: userDetail?.company_id}, (res)=>{
            setVisibleLoader(false);
            // console.log("Printing response in task_detail", res);
            if(res.data.status){
                const all_user_temp_arr = new Array();
                res.data.data.map((v)=>{
                    all_user_temp_arr.push(v.email);
                });
                setAllUser(all_user_temp_arr);
                ChangeOptionAddUser();
            }
            else{
                console.log(false);
            }
        }, (err)=>{
            console.log(err);
        })
    }, [userDetail])

    return (
        <>
            {visible_loader == true && <Loader />}
            <AlertDialog visible={visible_dialog} title={title_dialog} button={button_dialog} close={()=>{
                setVisibleDialog(false);
            }} />
            <div className="add_task">
                <div className="box">
                    <div className="input_div">
                        <h4>Title*</h4>
                        <input type="text" name="title" value={task_detail?.title} onChange={(e)=>{
                            console.log("Printing e.target.value", e.target.value);
                            setTaskDetail({...task_detail, title: e.target.value})
                        }} />
                    </div>
                    <div className="input_div">
                        <h4>Description</h4>
                        <textarea name="description" value={task_detail?.description} onChange={(e)=>{
                            setTaskDetail({...task_detail, description: e.target.value})
                        }} ></textarea>
                    </div>
                    <div className="input_div">
                        <h4 style={{marginBottom: "15px"}}>Assign work to any user*</h4>
                        <Autocomplete
                            disableClearable
                            onChange={(event, value)=>{
                                // console.log(value);
                                setSelectedUser(value);
                                setTaskDetail({...task_detail, assigned: value})
                            }}
                            multiple
                            id="add-user"
                            options={all_user}
                            getOptionLabel={(option) => option}
                            filterSelectedOptions
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                            />
                            )}
                        />
                    </div>
                    <div className='input_div'>
                        <h4>Due Date</h4>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                inputFormat={"dd/MM/yyyy"}
                                value={task_detail.dueDate}
                                onChange={(newValue)=>{
                                    console.log("Printing new value", newValue);
                                    let date = new Date(newValue);
                                    let value = (date.getMonth()+1) + "/" + date.getDate() + "/" + date.getFullYear();
                                    setTaskDetail({...task_detail, dueDate: value});
                                }}
                                renderInput={params=>{
                                    return (
                                        <TextField {...params} />
                                    )
                                }}
                            />
                        </LocalizationProvider>
                    </div>
                    <div className='input_div'>
                        <h4>CheckList</h4>
                        <button style={{background: "#4f62dd", color: "#fff", border: "none", padding: "5px 10px", borderRadius: "5px"}} onClick={()=>{
                                let temp = task_detail?.checkList === undefined ? [] : [...task_detail.checkList];
                                temp.push({
                                    id: new Date().getTime(),
                                    label: "",
                                    checked: false
                                })
                                setTaskDetail({...task_detail, checkList: temp });
                            }}>Add Check list</button>
                        <List style={{width: "90%"}}>
                        {
                            task_detail?.checkList?.length > 0 && task_detail?.checkList?.map((item)=>{
                                return (
                                    <ListItem style={{width: "100%"}}>
                                        <Checkbox checked={item.checked} onChange={(e)=>{setTaskDetail(prev=>{
                                            console.log("Printing previous state", prev);
                                            debugger;
                                            let temp = [...prev.checkList];
                                            temp = temp.filter((obj)=>{
                                                if(obj.id === item.id){
                                                    obj.checked = e.target.checked;
                                                }
                                                return obj
                                            })
                                            return {...task_detail, checkList: temp}
                                        })}} />
                                        <TextField variant='standard' style={{width: "100%"}} placeholder="Click here to edit..." value={item.label} onChange={(e)=>{ setTaskDetail(prev=>{
                                            console.log(e.target.value, prev);
                                            // debugger;
                                            let temp = [...prev.checkList];
                                            console.log(temp);
                                            temp = temp.filter((obj)=>{
                                                if(obj.id === item.id){
                                                    obj.label = e.target.value;
                                                }
                                                return obj;
                                            });
                                            console.log(temp);
                                            return {...task_detail, checkList: temp};
                                        }) }} />
                                        <DeleteIcon style={{cursor: "pointer"}} onClick={()=>{
                                            let temp = [...task_detail.checkList];
                                            temp = temp.filter((obj)=>{
                                                if(obj.id !== item.id){
                                                    return obj;
                                                }
                                            });
                                            setTaskDetail({...task_detail, checkList: temp});
                                        }} />
                                    </ListItem>
                                )
                            })
                        }
                        </List>
                    </div>
                    <div className="input_div">
                        <h4>Status*</h4>
                        {
                        status === "Not Started" && <Button style={{textTransform: "capitalize", fontSize: "18px", backgroundColor: "#16a085", color: "#fff"}}>{status}</Button>
                    }
                    {
                        status === "Development" && <Button style={{textTransform: "capitalize", fontSize: "18px", backgroundColor: "#e67e22", color: '#fff'}}>{status}</Button>
                    }
                    {
                        status === "Error" && <Button style={{textTransform: "capitalize", fontSize: "18px", backgroundColor: "#e74c3c", color: '#fff'}}>{status}</Button>
                    }
                    {
                        status === "QC" && <Button style={{textTransform: "capitalize", fontSize: "18px", backgroundColor: "#2980b9", color: '#fff'}}>{status}</Button>
                    }
                    {
                        status === "Reference" && <Button style={{textTransform: "capitalize", fontSize: "18px", backgroundColor: "#34495e", color: '#fff'}}>{status}</Button>
                    }
                    {
                        status === "Completed" && <Button style={{textTransform: "capitalize", fontSize: "18px", backgroundColor: "#27ae60", color: '#fff'}}>{status}</Button>
                    }
                    <Button style={{textTransform: "capitalize"}} id="change-status" aria-controls="fade-menu" aria-haspopup="true" onClick={handleClick}>
                        Change Status
                    </Button>
                    <Menu
                        id="fade-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={open}
                        onClose={()=>setAnchorEl(null)}
                        TransitionComponent={Fade}
                    >
                        {all_status.map((v)=>{
                            return <MenuItem onClick={()=>{
                                setStatus(v);
                                setTaskDetail({...task_detail, status: v})
                                setAnchorEl(null);
                            }}>{v}</MenuItem>
                        })}
                    </Menu>
                    </div>
                    <div className="submit_div">
                        <button onClick={AddTaskAPI}>Add Task</button>
                    </div>
                </div>
            </div>
        </>
    )
};

export default AddTask;